module.exports = __webpack_public_path__ + "static/media/vision-2030-footer.45f3ffb2.svg";